(() => {
  const STORAGE_KEY = 'qora_quiz_state_v1';
  const QORA_BOX_HANDLE = 'qora-box';

  // ------------------------------------------------------------------
  // Definición de los 13 pasos
  // ------------------------------------------------------------------
  const STEPS = [
    {
      id: 'tono_piel',
      title: '¿Cuál es tu tono de piel?',
      subtitle: 'Selecciona una opción.',
      type: 'skin',
      mode: 'single',
      options: [
        { value: 'muy_claro',       label: 'Muy claro',       color: '#F4DDC8' },
        { value: 'bronceado',       label: 'Bronceado',       color: '#A86E47' },
        { value: 'claro',           label: 'Claro',           color: '#E8C29C' },
        { value: 'profundo_medio',  label: 'Profundo medio',  color: '#7B4A2C' },
        { value: 'medio_claro',     label: 'Medio claro',     color: '#D4A579' },
        { value: 'profundo',        label: 'Profundo',        color: '#5B2E18' },
        { value: 'medio',           label: 'Medio',           color: '#C28959' },
        { value: 'muy_profundo',    label: 'Muy profundo',    color: '#3E1D10' },
        { value: 'medio_bronceado', label: 'Medio bronceado', color: '#B17646' },
      ],
    },
    {
      id: 'color_ojos',
      title: '¿De qué color son tus ojos?',
      subtitle: 'Selecciona una opción.',
      type: 'color',
      mode: 'single',
      cols: 4,
      options: [
        { value: 'castanos',        label: 'Castaños',        color: '#5C3A20' },
        { value: 'castanos_claros', label: 'Castaños Claros', color: '#A0764C' },
        { value: 'azules',          label: 'Azules',          color: '#5085A0' },
        { value: 'verdes',          label: 'Verdes',          color: '#789868' },
        { value: 'ambar',           label: 'Ámbar',           color: '#B07840' },
        { value: 'grises',          label: 'Grises',          color: '#A8A8A8' },
      ],
    },
    {
      id: 'color_cabello',
      title: '¿Cuál es el color de tu cabello?',
      subtitle: 'Selecciona una opción.',
      type: 'color',
      mode: 'single',
      cols: 4,
      options: [
        { value: 'negro',          label: 'Negro',          color: '#1A1010' },
        { value: 'castano_oscuro', label: 'Castaño Oscuro', color: '#3D2418' },
        { value: 'castano_claro',  label: 'Castaño Claro',  color: '#7B4A2C' },
        { value: 'rubio',          label: 'Rubio',          color: '#D9B97A' },
        { value: 'pelirrojo',      label: 'Pelirrojo',      color: '#9B4520' },
        { value: 'gris',           label: 'Gris',           color: '#6E6E6E' },
        { value: 'blanco',         label: 'Blanco',         color: '#E5E5E5' },
      ],
    },
    {
      id: 'comodidad_maquillaje',
      title: '¿Qué tan cómoda te sientes con el maquillaje?',
      subtitle: 'Selecciona una opción.',
      type: 'radio',
      mode: 'single',
      options: [
        { value: 'no_muy_comoda', label: 'No muy cómoda',
          desc: 'Rara vez o nunca uso maquillaje porque no me gusta o no sé cómo aplicarlo.' },
        { value: 'algo_comoda', label: 'Algo cómoda',
          desc: 'Me gusta el maquillaje, pero estoy buscando aprender más sobre qué usar y cómo usarlo.' },
        { value: 'muy_comoda', label: 'Muy cómoda',
          desc: '¡Soy profesional del maquillaje y nunca salgo de casa sin lucir glamorosa!' },
      ],
    },
    {
      id: 'frecuencia_ojos_labios',
      title: '¿Con qué frecuencia deseas recibir los siguientes productos para ojos y labios?',
      subtitle: 'Elige una frecuencia para cada producto.',
      type: 'frequency',
      items: [
        { id: 'mascara',  label: 'Máscara',  emoji: '👁️' },
        { id: 'cejas',    label: 'Cejas',    emoji: '✏️' },
        { id: 'sombras',  label: 'Sombras',  emoji: '🎨' },
        { id: 'delineador', label: 'Delineador', emoji: '🖋️' },
        { id: 'labial', label: 'Labial', emoji: '💋' },
      ],
    },
    {
      id: 'tonos_ojos_labios',
      title: '¿Qué tonos prefieres recibir?',
      subtitle: 'Selecciona todos los que apliquen.',
      type: 'tone-groups',
      mode: 'multi',
      groups: [
        {
          label: 'Ojos',
          options: [
            { value: 'ojos_negro',     label: 'Negro',          color: '#1A1010' },
            { value: 'ojos_cafe',      label: 'Cafés',          color: '#7B4A2C' },
            { value: 'ojos_morados',   label: 'Morados',        color: '#6E3C8B' },
            { value: 'ojos_dorado',    label: 'Dorado/Bronce',  color: '#C9A85C' },
            { value: 'ojos_aventureros', label: 'Aventureros',  color: '#3050A0' },
          ],
        },
        {
          label: 'Labios',
          options: [
            { value: 'labios_rojos',     label: 'Rojos',     color: '#C42030' },
            { value: 'labios_bayas',     label: 'Bayas',     color: '#8B2540' },
            { value: 'labios_neutros',   label: 'Neutros',   color: '#B07060' },
            { value: 'labios_aventureros', label: 'Aventureros', color: '#E63E5C' },
          ],
        },
      ],
    },
    {
      id: 'frecuencia_unas_rostro',
      title: '¿Con qué frecuencia deseas recibir los siguientes productos para uñas y rostro?',
      subtitle: 'Elige una frecuencia para cada producto.',
      type: 'frequency',
      items: [
        { id: 'primer_rostro', label: 'Primer para Rostro', emoji: '✨' },
        { id: 'corrector',    label: 'Corrector',          emoji: '🩹' },
        { id: 'base',         label: 'Base',               emoji: '🧴' },
        { id: 'humectante',   label: 'Humectante',         emoji: '💧' },
        { id: 'polvos',       label: 'Polvos',             emoji: '🌫️' },
        { id: 'rubor',        label: 'Rubor',              emoji: '🌸' },
        { id: 'iluminador',   label: 'Iluminador',         emoji: '🌟' },
        { id: 'bronceador',   label: 'Bronceador',         emoji: '☀️' },
        { id: 'esmalte_unas', label: 'Esmalte de uñas',    emoji: '💅' },
      ],
    },
    {
      id: 'tonos_rostro',
      title: '¿Qué tonos prefieres recibir para esos productos?',
      subtitle: 'Selecciona todos los que apliquen.',
      type: 'tone',
      mode: 'multi',
      cols: 3,
      options: [
        { value: 'rosados',  label: 'Rosados',  color: '#E89DB6' },
        { value: 'duraznos', label: 'Duraznos', color: '#F2A98B' },
        { value: 'lavanda',  label: 'Lavanda',  color: '#C6B0D9' },
        { value: 'neutros',  label: 'Neutros',  color: '#D5BBA0' },
        { value: 'aventureros', label: 'Aventureros', color: '#D8276B' },
      ],
    },
    {
      id: 'frecuencia_piel',
      title: '¿Con qué frecuencia deseas recibir los siguientes productos para el cuidado de tu piel?',
      subtitle: 'Elige una frecuencia para cada producto.',
      type: 'frequency',
      items: [
        { id: 'limpiador',         label: 'Limpiador',           emoji: '🫧' },
        { id: 'limpiador_aceite',  label: 'Limpiador en Aceite', emoji: '🛢️' },
        { id: 'humectante_facial', label: 'Humectante',          emoji: '💧' },
        { id: 'mascarilla_tela',   label: 'Mascarillas de Tela', emoji: '🎭' },
        { id: 'mascarilla_lavable', label: 'Mascarilla Lavable', emoji: '🧖' },
        { id: 'exfoliante',        label: 'Exfoliante',          emoji: '🌿' },
        { id: 'sueros',            label: 'Sueros',              emoji: '🧪' },
        { id: 'aceite_facial',     label: 'Aceite Facial',       emoji: '🌹' },
        { id: 'tonificador',       label: 'Tonificador',         emoji: '🌊' },
        { id: 'contorno_ojos',     label: 'Contorno de Ojos',    emoji: '👁️' },
        { id: 'balsamo_labial',    label: 'Bálsamo Labial',      emoji: '💋' },
        { id: 'tratamiento_acne',  label: 'Tratamiento para Acné', emoji: '🎯' },
      ],
    },
    {
      id: 'frecuencia_cuerpo_cabello',
      title: '¿Con qué frecuencia deseas recibir los siguientes productos para cuerpo y cabello?',
      subtitle: 'Elige una frecuencia para cada producto.',
      type: 'frequency',
      items: [
        { id: 'peinado',          label: 'Productos para Peinado',  emoji: '💇' },
        { id: 'tratamiento_pelo', label: 'Tratamiento para el cabello', emoji: '💆' },
        { id: 'autobronceador',   label: 'Autobronceador',          emoji: '🌞' },
        { id: 'exfoliante_corp',  label: 'Exfoliante Corporal',     emoji: '🧂' },
        { id: 'crema_manos',      label: 'Crema para Manos',        emoji: '🤲' },
        { id: 'crema_corporal',   label: 'Crema Corporal',          emoji: '🧴' },
      ],
    },
    {
      id: 'marcas_preferidas',
      title: '¿Qué marcas te gustan o te gustaría probar?',
      subtitle: 'Selecciona todas las que apliquen. Siempre recibirás una combinación de marcas para descubrir nuevos favoritos.',
      type: 'brand',
      mode: 'multi',
      cols: 4,
      options: [
        { value: 'qora',         label: 'Qora' },
        { value: 'elf',          label: 'ELF' },
        { value: 'revolution',   label: 'Revolution' },
        { value: 'loreal',       label: "L'Oréal" },
        { value: 'dior',         label: 'Dior' },
        { value: 'makeup_mario', label: 'Makeup byMario' },
        { value: 'mac',          label: 'MAC' },
        { value: 'fenty',        label: 'Fenty Beauty' },
        { value: 'clinique',     label: 'Clinique' },
        { value: 'milani',       label: 'Milani' },
        { value: 'morphe',       label: 'Morphe' },
        { value: 'olaplex',      label: 'Olaplex' },
        { value: 'the_ordinary', label: 'The Ordinary' },
        { value: 'glow_recipe',  label: 'Glow Recipe' },
        { value: 'smashbox',     label: 'Smashbox' },
        { value: 'benefit',      label: 'Benefit' },
      ],
    },
    {
      id: 'preocupaciones_piel',
      title: '¿Cómo describirías tus preocupaciones sobre la piel?',
      subtitle: 'Selecciona todas las que apliquen.',
      type: 'icon',
      mode: 'multi',
      cols: 3,
      options: [
        { value: 'enrojecimiento',  label: 'Enrojecimiento',         icon: 'flame' },
        { value: 'lineas_arrugas',  label: 'Líneas Finas y Arrugas', icon: 'wave' },
        { value: 'hiperpigmentacion', label: 'Hiperpigmentación',    icon: 'sun' },
        { value: 'acne',            label: 'Acné e Imperfecciones',  icon: 'spots' },
        { value: 'resequedad',      label: 'Resequedad',             icon: 'cactus' },
        { value: 'grasa_poros',     label: 'Grasa y Poros Dilatados', icon: 'drop' },
      ],
    },
    {
      id: 'cabello',
      title: 'Última pregunta. ¿Cómo describirías tu cabello?',
      subtitle: 'Selecciona todas las que apliquen.',
      type: 'icon',
      mode: 'multi',
      cols: 4,
      options: [
        { value: 'necesita_volumen', label: 'Necesita Volumen', icon: 'volume' },
        { value: 'rizo_extremo',     label: 'Rizo Extremo',     icon: 'curl' },
        { value: 'seco_danado',      label: 'Seco y Dañado',    icon: 'cactus' },
        { value: 'rizado',           label: 'Rizado',           icon: 'wave' },
        { value: 'puntas_abiertas',  label: 'Puntas Abiertas',  icon: 'splits' },
      ],
    },
  ];

  const ICONS = {
    flame: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M12 22c4 0 7-3 7-7 0-3-2-5-3-7-1-2-1-4-1-5-2 1-5 4-5 7 0-2-1-3-2-4-1 2-3 4-3 7 0 5 3 9 7 9Z" stroke-linejoin="round"/></svg>',
    wave: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"><path d="M3 9c2-3 4-3 6 0s4 3 6 0 4-3 6 0M3 15c2-3 4-3 6 0s4 3 6 0 4-3 6 0"/></svg>',
    sun: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><circle cx="12" cy="12" r="4"/><path stroke-linecap="round" d="M12 3v2M12 19v2M3 12h2M19 12h2M5.6 5.6l1.4 1.4M17 17l1.4 1.4M5.6 18.4 7 17M17 7l1.4-1.4"/></svg>',
    spots: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><circle cx="12" cy="12" r="9"/><circle cx="8" cy="9" r="1.2" fill="currentColor"/><circle cx="15" cy="11" r="1.2" fill="currentColor"/><circle cx="10" cy="15" r="1.2" fill="currentColor"/><circle cx="16" cy="16" r="1" fill="currentColor"/></svg>',
    cactus: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"><path d="M10 21h4M9 21V7a3 3 0 0 1 6 0v14M9 12H7a2 2 0 0 1-2-2v-1a2 2 0 0 1 2-2h2M15 14h2a2 2 0 0 0 2-2v-1a2 2 0 0 0-2-2h-2"/></svg>',
    drop: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M12 3s-6 7-6 11a6 6 0 0 0 12 0c0-4-6-11-6-11Z" stroke-linejoin="round"/></svg>',
    volume: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"><path d="M6 14c0-4 2-8 6-8s6 4 6 8M4 14c0-6 3-10 8-10s8 4 8 10M6 14v6M12 14v6M18 14v6"/></svg>',
    curl: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"><path d="M5 6c2 0 3 1.5 3 3s-1 3-3 3 1.5-3 3-3M11 6c2 0 3 1.5 3 3s-1 3-3 3 1.5-3 3-3M17 6c2 0 3 1.5 3 3s-1 3-3 3 1.5-3 3-3M5 13v8M12 13v8M19 13v8"/></svg>',
    splits: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"><path d="M12 3v12M9 15l3 6M15 15l-3 6M10 8l4 0M9 11l6 0"/></svg>',
  };

  // Iconos abstractos para marcas — sin replicar logos reales
  const BRAND_ICONS = {
    qora:         '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M12 3c2.5 2 4 4 4 7s-1.5 5-4 7c-2.5-2-4-4-4-7s1.5-5 4-7Z" stroke-linejoin="round"/><circle cx="12" cy="10" r="1.5" fill="currentColor"/></svg>',
    elf:          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"><path d="m12 3 2.4 5.6L20 9.4l-4.3 4 1.1 5.9L12 16.5l-4.8 2.8 1.1-5.9L4 9.4l5.6-.8L12 3Z"/></svg>',
    revolution:   '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round" stroke-linecap="round"><path d="M13 3 5 13h6l-1 8 8-10h-6l1-8Z"/></svg>',
    loreal:       '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"><path d="M12 3c4 4 4 8 0 12-4-4-4-8 0-12Z"/><path d="M12 15c-3 1.5-6 3-6 5h12c0-2-3-3.5-6-5Z"/></svg>',
    dior:         '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"><path d="m12 3 5 6-5 12-5-12 5-6Z"/><path d="m7 9 10 0"/></svg>',
    makeup_mario: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round" stroke-linecap="round"><path d="M4 20 14 10l3 3L7 23H4v-3Z"/><path d="m13 9 3 3 3-3-3-3-3 3Z"/></svg>',
    mac:          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><circle cx="12" cy="12" r="9"/><circle cx="12" cy="12" r="5"/><circle cx="12" cy="12" r="1.5" fill="currentColor"/></svg>',
    fenty:        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"><path d="m4 9 3-4h10l3 4-8 11L4 9Z"/><path d="m9 5 3 4 3-4M4 9h16"/></svg>',
    clinique:     '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><circle cx="12" cy="12" r="9"/><path stroke-linecap="round" d="M12 7v10M7 12h10"/></svg>',
    milani:       '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M4 19V8l4 6 4-6 4 6 4-6v11"/></svg>',
    morphe:       '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"><path d="m12 3 8 4.5v9L12 21l-8-4.5v-9L12 3Z"/></svg>',
    olaplex:      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"><path d="M9 8a4 4 0 0 0 0 8h2M15 8a4 4 0 0 1 0 8h-2M9 12h6"/></svg>',
    the_ordinary: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M9 5h6v3l-1 1v10a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1V9l-1-1V5Z" stroke-linejoin="round"/></svg>',
    glow_recipe:  '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="m12 3 1.5 4.5L18 9l-4.5 1.5L12 15l-1.5-4.5L6 9l4.5-1.5L12 3Z"/><path d="m19 14 .8 2.2L22 17l-2.2.8L19 20l-.8-2.2L16 17l2.2-.8L19 14ZM5 14l.8 2.2L8 17l-2.2.8L5 20l-.8-2.2L2 17l2.2-.8L5 14Z"/></svg>',
    smashbox:     '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"><path d="M4 8h16v12H4z"/><path d="m4 8 2-4h12l2 4M10 12h4"/></svg>',
    benefit:      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"><path d="M12 20s-7-4-7-10a4 4 0 0 1 7-2.5A4 4 0 0 1 19 10c0 6-7 10-7 10Z"/></svg>',
  };

  // ------------------------------------------------------------------
  // Estado
  // ------------------------------------------------------------------
  const state = {
    index: 0,
    answers: {},
  };

  // ------------------------------------------------------------------
  // Refs DOM
  // ------------------------------------------------------------------
  const els = {};

  // ------------------------------------------------------------------
  // Helpers
  // ------------------------------------------------------------------
  const save = () => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify({ index: state.index, answers: state.answers }));
    } catch (_) {}
  };

  const load = () => {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return;
      const parsed = JSON.parse(raw);
      if (parsed && typeof parsed === 'object') {
        state.index = parsed.index || 0;
        state.answers = parsed.answers || {};
      }
    } catch (_) {}
  };

  const clearSaved = () => {
    try { localStorage.removeItem(STORAGE_KEY); } catch (_) {}
  };

  const isStepComplete = (step) => {
    const a = state.answers[step.id];
    if (step.type === 'frequency') {
      return a && step.items.every((it) => a[it.id]);
    }
    if (step.type === 'tone-groups') {
      return Array.isArray(a) && a.length > 0;
    }
    if (step.mode === 'multi') return Array.isArray(a) && a.length > 0;
    return !!a;
  };

  // ------------------------------------------------------------------
  // Toggle de selección sin re-renderizar (no scrollea al top)
  // ------------------------------------------------------------------
  const refreshSelection = (step) => {
    const root = els.stepEl;
    const a = state.answers[step.id];
    if (step.type === 'frequency') {
      const current = a || {};
      root.querySelectorAll('[data-quiz-item]').forEach((row) => {
        const itemId = row.dataset.quizItem;
        const sel = current[itemId];
        row.classList.toggle('is-active', !!sel);
        row.querySelectorAll('[data-freq]').forEach((btn) => {
          btn.classList.toggle('is-active', btn.dataset.freq === sel);
        });
      });
      return;
    }
    const isMulti = step.mode === 'multi' || step.type === 'tone-groups';
    root.querySelectorAll('[data-quiz-option]').forEach((el) => {
      const v = el.dataset.quizOption;
      const active = isMulti ? Array.isArray(a) && a.includes(v) : a === v;
      el.classList.toggle('is-selected', active);
    });
  };

  const handleSingleClick = (step, value) => {
    state.answers[step.id] = value;
    refreshSelection(step);
    updateNext();
    save();
  };

  const handleMultiClick = (step, value) => {
    const list = Array.isArray(state.answers[step.id]) ? state.answers[step.id] : [];
    const idx = list.indexOf(value);
    if (idx >= 0) list.splice(idx, 1); else list.push(value);
    state.answers[step.id] = list;
    refreshSelection(step);
    updateNext();
    save();
  };

  // ------------------------------------------------------------------
  // Renderers por tipo
  // ------------------------------------------------------------------
  const renderSkin = (step) => {
    const sel = state.answers[step.id];
    const grid = document.createElement('div');
    grid.className = 'cherry-quiz__grid cherry-quiz__grid--cols-2';
    step.options.forEach((opt) => {
      const tile = document.createElement('button');
      tile.type = 'button';
      tile.dataset.quizOption = opt.value;
      tile.className = 'cherry-quiz__skin-tile' + (sel === opt.value ? ' is-selected' : '');
      tile.style.backgroundImage = `linear-gradient(135deg, ${opt.color}, ${shade(opt.color, -25)})`;
      tile.innerHTML = `
        <span class="cherry-quiz__skin-tile-check"><svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="m3 7 3 3 5-6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg></span>
        ${opt.label}
      `;
      tile.addEventListener('click', () => handleSingleClick(step, opt.value));
      grid.appendChild(tile);
    });
    return grid;
  };

  const renderColor = (step) => {
    const sel = state.answers[step.id];
    const grid = document.createElement('div');
    grid.className = `cherry-quiz__grid cherry-quiz__grid--cols-${step.cols || 4}`;
    step.options.forEach((opt) => {
      const tile = document.createElement('button');
      tile.type = 'button';
      tile.dataset.quizOption = opt.value;
      tile.className = 'cherry-quiz__color-tile' + (sel === opt.value ? ' is-selected' : '');
      tile.innerHTML = `
        <span class="cherry-quiz__color-circle" style="background:${opt.color}"></span>
        <span class="cherry-quiz__color-tile-check"><svg width="20" height="20" viewBox="0 0 14 14" fill="none"><path d="m3 7 3 3 5-6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg></span>
        <span class="cherry-quiz__color-tile-label">${opt.label}</span>
      `;
      tile.addEventListener('click', () => handleSingleClick(step, opt.value));
      grid.appendChild(tile);
    });
    return grid;
  };

  const renderRadio = (step) => {
    const sel = state.answers[step.id];
    const wrap = document.createElement('div');
    wrap.className = 'cherry-quiz__grid';
    wrap.style.gridTemplateColumns = '1fr';
    step.options.forEach((opt) => {
      const tile = document.createElement('button');
      tile.type = 'button';
      tile.dataset.quizOption = opt.value;
      tile.className = 'cherry-quiz__radio-tile' + (sel === opt.value ? ' is-selected' : '');
      tile.innerHTML = `
        <span class="cherry-quiz__radio-mark"></span>
        <span class="cherry-quiz__radio-body">
          <span class="cherry-quiz__radio-title">${opt.label}</span>
          <span class="cherry-quiz__radio-desc">${opt.desc}</span>
        </span>
      `;
      tile.addEventListener('click', () => handleSingleClick(step, opt.value));
      wrap.appendChild(tile);
    });
    return wrap;
  };

  const renderFrequency = (step) => {
    const current = state.answers[step.id] || {};
    state.answers[step.id] = current;
    const wrap = document.createElement('div');
    wrap.className = 'cherry-quiz__freq-list';
    step.items.forEach((it) => {
      const sel = current[it.id];
      const row = document.createElement('div');
      row.className = 'cherry-quiz__freq-row' + (sel ? ' is-active' : '');
      row.dataset.quizItem = it.id;
      const freqs = [
        { id: 'raramente', label: 'Raramente' },
        { id: 'a_veces',   label: 'A veces' },
        { id: 'a_menudo',  label: 'A menudo' },
      ];
      row.innerHTML = `
        <div class="cherry-quiz__freq-img" data-emoji="${it.emoji}"></div>
        <div class="cherry-quiz__freq-body">
          <span class="cherry-quiz__freq-label">${it.label}</span>
          <div class="cherry-quiz__freq-buttons">
            ${freqs.map((f) => `<button type="button" class="cherry-quiz__freq-btn${sel === f.id ? ' is-active' : ''}" data-freq="${f.id}">${f.label}</button>`).join('')}
          </div>
        </div>
      `;
      row.querySelectorAll('[data-freq]').forEach((btn) => {
        btn.addEventListener('click', () => {
          current[it.id] = btn.dataset.freq;
          refreshSelection(step);
          updateNext();
          save();
        });
      });
      wrap.appendChild(row);
    });
    return wrap;
  };

  const renderTone = (step) => {
    const sel = state.answers[step.id] || [];
    state.answers[step.id] = Array.isArray(sel) ? sel : [];
    const grid = document.createElement('div');
    grid.className = `cherry-quiz__grid cherry-quiz__grid--cols-${step.cols || 3}`;
    step.options.forEach((opt) => {
      const active = state.answers[step.id].includes(opt.value);
      const tile = document.createElement('button');
      tile.type = 'button';
      tile.dataset.quizOption = opt.value;
      tile.className = 'cherry-quiz__tone-tile' + (active ? ' is-selected' : '');
      tile.innerHTML = `
        <span class="cherry-quiz__tone-tile-swatch" style="background:linear-gradient(135deg, ${shade(opt.color, 18)}, ${opt.color}, ${shade(opt.color, -20)})"></span>
        <span class="cherry-quiz__tone-tile-check"><svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="m3 7 3 3 5-6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg></span>
        <span class="cherry-quiz__tone-tile-label">${opt.label}</span>
      `;
      tile.addEventListener('click', () => handleMultiClick(step, opt.value));
      grid.appendChild(tile);
    });
    return grid;
  };

  const renderToneGroups = (step) => {
    const sel = state.answers[step.id] || [];
    state.answers[step.id] = Array.isArray(sel) ? sel : [];
    const wrap = document.createElement('div');
    step.groups.forEach((grp) => {
      const groupBox = document.createElement('div');
      groupBox.className = 'cherry-quiz__tone-group';
      groupBox.innerHTML = `<h3 class="cherry-quiz__tone-group-title">${grp.label}</h3>`;
      const grid = document.createElement('div');
      grid.className = 'cherry-quiz__grid cherry-quiz__grid--cols-3';
      grp.options.forEach((opt) => {
        const active = state.answers[step.id].includes(opt.value);
        const tile = document.createElement('button');
        tile.type = 'button';
        tile.dataset.quizOption = opt.value;
        tile.className = 'cherry-quiz__tone-tile' + (active ? ' is-selected' : '');
        tile.innerHTML = `
          <span class="cherry-quiz__tone-tile-swatch" style="background:linear-gradient(135deg, ${shade(opt.color, 18)}, ${opt.color}, ${shade(opt.color, -20)})"></span>
          <span class="cherry-quiz__tone-tile-check"><svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="m3 7 3 3 5-6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg></span>
          <span class="cherry-quiz__tone-tile-label">${opt.label}</span>
        `;
        tile.addEventListener('click', () => handleMultiClick(step, opt.value));
        grid.appendChild(tile);
      });
      groupBox.appendChild(grid);
      wrap.appendChild(groupBox);
    });
    return wrap;
  };

  const renderBrand = (step) => {
    const sel = state.answers[step.id] || [];
    state.answers[step.id] = Array.isArray(sel) ? sel : [];
    const wrap = document.createElement('div');
    const grid = document.createElement('div');
    grid.className = `cherry-quiz__grid cherry-quiz__grid--cols-${step.cols || 4}`;
    step.options.forEach((opt) => {
      const active = state.answers[step.id].includes(opt.value);
      const tile = document.createElement('button');
      tile.type = 'button';
      tile.dataset.quizOption = opt.value;
      tile.className = 'cherry-quiz__brand-tile' + (active ? ' is-selected' : '');
      const icon = BRAND_ICONS[opt.value] || BRAND_ICONS.qora;
      tile.innerHTML = `
        <span class="cherry-quiz__brand-tile-check"><svg width="12" height="12" viewBox="0 0 14 14" fill="none"><path d="m3 7 3 3 5-6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg></span>
        <span class="cherry-quiz__brand-tile-svg">${icon}</span>
        <span class="cherry-quiz__brand-tile-label">${opt.label}</span>
      `;
      tile.addEventListener('click', () => handleMultiClick(step, opt.value));
      grid.appendChild(tile);
    });
    wrap.appendChild(grid);

    const hint = document.createElement('div');
    hint.className = 'cherry-quiz__hint';
    hint.innerHTML = `
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none"><circle cx="8" cy="8" r="6.5" stroke="currentColor" stroke-width="1.4"/><path d="M8 7v4M8 5v.5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>
      Siempre recibirás una combinación de marcas para ayudarte a descubrir nuevos favoritos.
    `;
    wrap.appendChild(hint);
    return wrap;
  };

  const renderIcon = (step) => {
    const sel = state.answers[step.id] || [];
    state.answers[step.id] = Array.isArray(sel) ? sel : [];
    const grid = document.createElement('div');
    grid.className = `cherry-quiz__grid cherry-quiz__grid--cols-${step.cols || 3}`;
    step.options.forEach((opt) => {
      const active = state.answers[step.id].includes(opt.value);
      const tile = document.createElement('button');
      tile.type = 'button';
      tile.dataset.quizOption = opt.value;
      tile.className = 'cherry-quiz__icon-tile' + (active ? ' is-selected' : '');
      tile.innerHTML = `
        <span class="cherry-quiz__icon-tile-check"><svg width="12" height="12" viewBox="0 0 14 14" fill="none"><path d="m3 7 3 3 5-6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg></span>
        <span class="cherry-quiz__icon-tile-svg">${ICONS[opt.icon] || ICONS.drop}</span>
        <span class="cherry-quiz__icon-tile-label">${opt.label}</span>
      `;
      tile.addEventListener('click', () => handleMultiClick(step, opt.value));
      grid.appendChild(tile);
    });
    return grid;
  };

  // ------------------------------------------------------------------
  // Shade util — aclara/oscurece un hex
  // ------------------------------------------------------------------
  const shade = (hex, percent) => {
    const c = hex.replace('#', '');
    const r = parseInt(c.substring(0, 2), 16);
    const g = parseInt(c.substring(2, 4), 16);
    const b = parseInt(c.substring(4, 6), 16);
    const adjust = (v) => {
      const out = v + (percent / 100) * 255;
      return Math.max(0, Math.min(255, Math.round(out)));
    };
    const toHex = (v) => v.toString(16).padStart(2, '0');
    return `#${toHex(adjust(r))}${toHex(adjust(g))}${toHex(adjust(b))}`;
  };

  // ------------------------------------------------------------------
  // Render del paso actual
  // ------------------------------------------------------------------
  const renderStep = () => {
    const step = STEPS[state.index];
    if (!step) return;
    els.title.textContent = step.title;
    els.subtitle.textContent = step.subtitle || '';
    els.counter.textContent = `Paso ${state.index + 1} de ${STEPS.length}`;
    els.progress.style.width = `${((state.index + 1) / STEPS.length) * 100}%`;
    els.back.hidden = state.index === 0;

    els.stepEl.innerHTML = '';
    let content;
    switch (step.type) {
      case 'skin':         content = renderSkin(step); break;
      case 'color':        content = renderColor(step); break;
      case 'radio':        content = renderRadio(step); break;
      case 'frequency':    content = renderFrequency(step); break;
      case 'tone':         content = renderTone(step); break;
      case 'tone-groups':  content = renderToneGroups(step); break;
      case 'brand':        content = renderBrand(step); break;
      case 'icon':         content = renderIcon(step); break;
      default: content = document.createElement('div');
    }
    els.stepEl.appendChild(content);

    els.main.scrollTop = 0;
  };

  const updateNext = () => {
    const step = STEPS[state.index];
    const complete = isStepComplete(step);
    els.next.disabled = !complete;
    if (state.index === STEPS.length - 1 && complete) {
      els.next.querySelector('svg').style.display = 'none';
      els.next.childNodes[0].nodeValue = 'Finalizar quiz ';
    } else {
      els.next.querySelector('svg').style.display = '';
      els.next.childNodes[0].nodeValue = 'Siguiente ';
    }
  };

  const goNext = () => {
    if (state.index < STEPS.length - 1) {
      state.index += 1;
      save();
      renderStep();
      updateNext();
      if (window.cherry && window.cherry.track) {
        window.cherry.track('quiz_step', {
          quiz: 'qora_box',
          step: state.index + 1,
          step_id: STEPS[state.index].id,
          total: STEPS.length,
        });
      }
    } else {
      showDone();
      if (window.cherry && window.cherry.track) {
        window.cherry.track('complete_quiz', {
          quiz: 'qora_box',
          plan: els.drawer.dataset.lastPlan || 'mensual',
          total_steps: STEPS.length,
        });
      }
    }
  };

  const goBack = () => {
    if (state.index > 0) {
      state.index -= 1;
      save();
      renderStep();
      updateNext();
    }
  };

  const showDone = () => {
    els.done.hidden = false;
  };

  const hideDone = () => {
    els.done.hidden = true;
  };

  // ------------------------------------------------------------------
  // Open / Close
  // ------------------------------------------------------------------
  const open = () => {
    els.drawer.classList.add('is-open');
    els.drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('cherry-quiz-locked');
    renderStep();
    updateNext();
    if (window.cherry && window.cherry.track) {
      window.cherry.track('start_quiz', {
        quiz: 'qora_box',
        plan: els.drawer.dataset.lastPlan || 'mensual',
        from_step: state.index + 1,
      });
    }
  };

  const close = () => {
    els.drawer.classList.remove('is-open');
    els.drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('cherry-quiz-locked');
    hideDone();
  };

  // ------------------------------------------------------------------
  // Add to cart (con line item properties)
  // ------------------------------------------------------------------
  const fetchQoraBoxVariantId = async (planKey) => {
    try {
      const res = await fetch(`/products/${QORA_BOX_HANDLE}.js`);
      if (!res.ok) return null;
      const product = await res.json();
      const planMap = { mensual: 'mensual', trimestral: 'trimestral', anual: 'anual' };
      const wanted = (planMap[planKey] || 'mensual').toLowerCase();
      const variant = product.variants.find((v) => (v.title || '').toLowerCase().includes(wanted))
        || product.variants.find((v) => v.available)
        || product.variants[0];
      return variant ? variant.id : null;
    } catch (err) {
      console.error('Qora Box fetch error', err);
      return null;
    }
  };

  const labelFor = (stepId, value) => {
    const step = STEPS.find((s) => s.id === stepId);
    if (!step) return value;
    if (step.options) {
      const opt = step.options.find((o) => o.value === value);
      return opt ? opt.label : value;
    }
    if (step.groups) {
      for (const g of step.groups) {
        const o = g.options.find((o) => o.value === value);
        if (o) return o.label;
      }
    }
    return value;
  };

  const buildProperties = () => {
    const props = {};
    STEPS.forEach((step) => {
      const a = state.answers[step.id];
      if (a == null) return;
      if (step.type === 'frequency') {
        const items = step.items
          .map((it) => a[it.id] ? `${it.label}: ${a[it.id].replace('_', ' ')}` : null)
          .filter(Boolean);
        if (items.length) props[step.title] = items.join(' · ');
      } else if (Array.isArray(a)) {
        if (a.length) props[step.title] = a.map((v) => labelFor(step.id, v)).join(', ');
      } else {
        props[step.title] = labelFor(step.id, a);
      }
    });
    return props;
  };

  const addToCart = async (planKey = 'mensual') => {
    const variantId = await fetchQoraBoxVariantId(planKey);
    if (!variantId) {
      alert('No pudimos encontrar el producto Qora Box. Reintentá en unos segundos.');
      return;
    }
    const properties = buildProperties();
    const fd = new FormData();
    fd.append('id', String(variantId));
    fd.append('quantity', '1');
    Object.entries(properties).forEach(([k, v]) => fd.append(`properties[${k}]`, v));
    try {
      const res = await fetch('/cart/add.js', { method: 'POST', body: fd });
      if (!res.ok) throw new Error('add failed');
      clearSaved();
      close();
      document.dispatchEvent(new CustomEvent('cherry:cart-add'));
      if (window.cherry && window.cherry.track) {
        window.cherry.track('subscribe_qora_box', {
          plan: planKey,
          variant_id: String(variantId),
          quiz_answered: true,
        });
      }
      const cartLink = document.getElementById('cherry-cart-link');
      if (cartLink) cartLink.click();
    } catch (err) {
      console.error(err);
      alert('No pudimos agregar al carrito. Intentá de nuevo.');
    }
  };

  // ------------------------------------------------------------------
  // Init
  // ------------------------------------------------------------------
  const init = () => {
    els.drawer = document.querySelector('[data-cherry-quiz]');
    if (!els.drawer) return;
    els.main = els.drawer.querySelector('[data-cherry-quiz-main]');
    els.stepEl = els.drawer.querySelector('[data-cherry-quiz-step]');
    els.title = els.drawer.querySelector('[data-cherry-quiz-title]');
    els.subtitle = els.drawer.querySelector('[data-cherry-quiz-subtitle]');
    els.counter = els.drawer.querySelector('[data-cherry-quiz-counter]');
    els.progress = els.drawer.querySelector('[data-cherry-quiz-progress]');
    els.back = els.drawer.querySelector('[data-cherry-quiz-back]');
    els.next = els.drawer.querySelector('[data-cherry-quiz-next]');
    els.done = els.drawer.querySelector('[data-cherry-quiz-done]');

    els.back.addEventListener('click', goBack);
    els.next.addEventListener('click', goNext);
    els.drawer.querySelector('[data-cherry-quiz-close]').addEventListener('click', close);
    els.drawer.querySelector('[data-cherry-quiz-restart]').addEventListener('click', () => {
      state.index = 0;
      state.answers = {};
      clearSaved();
      hideDone();
      renderStep();
      updateNext();
    });
    els.drawer.querySelector('[data-cherry-quiz-add-to-cart]').addEventListener('click', () => {
      const triggerPlan = els.drawer.dataset.lastPlan || 'mensual';
      addToCart(triggerPlan);
    });

    document.addEventListener('keydown', (e) => {
      if (!els.drawer.classList.contains('is-open')) return;
      if (e.key === 'Escape') close();
    });

    document.addEventListener('click', (e) => {
      const trigger = e.target.closest('[data-cherry-quiz-open]');
      if (!trigger) return;
      e.preventDefault();
      const plan = trigger.dataset.cherryQuizOpen || trigger.dataset.plan || 'mensual';
      els.drawer.dataset.lastPlan = plan;
      load();
      open();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
